"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaleBaseAllocation = void 0;
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _launchpadConstants_1 = require("../../launchpadConstants");
var usePool_1 = require("../../pool/hooks/usePool");
var usePriceConverters_1 = require("../../pool/hooks/usePriceConverters");
var types_1 = require("../../pool/types");
var utils_1 = require("../../pool/utils");
var utils_2 = require("../../shared/utils");
var useLevelManager_1 = require("../../tiers/hooks/useLevelManager");
function useSaleBaseAllocation(whitelistedN) {
    var _a, _b;
    if (whitelistedN === void 0) { whitelistedN = 100; }
    var _c = (0, usePool_1.usePool)(), sale = _c.pool.sale, staticSaleInstance = _c.staticSaleInstance;
    var _d = (0, usePriceConverters_1.usePriceConverters)(), tokensToCurrency = _d.tokensToCurrency, currencyToTokens = _d.currencyToTokens;
    var _e = (0, react_1.useState)(_launchpadConstants_1.ZERO_BN), autoAllocation = _e[0], setAutoAllocation = _e[1];
    (0, react_1.useEffect)(function () {
        if (!staticSaleInstance ||
            !(0, utils_1.isNFTSale)(sale) ||
            sale.status === types_1.SaleStatus.finished)
            return;
        (0, utils_2.call)(staticSaleInstance, 'autoBaseAllocation').then(function (v) {
            return setAutoAllocation((0, web3_utils_1.toBN)(v));
        });
    }, [staticSaleInstance]);
    if ((0, utils_1.isNFTSale)(sale)) {
        if (sale.baseAllocation.gtn(0)) {
            return {
                baseTokensAllocation: 0,
                baseCurrencyAllocation: sale.baseAllocation,
                isApprox: false,
            };
        }
        return {
            baseTokensAllocation: 0,
            baseCurrencyAllocation: autoAllocation,
            isApprox: true,
        };
    }
    if (sale.baseAllocation.gtn(0)) {
        return {
            baseTokensAllocation: sale.baseAllocation,
            baseCurrencyAllocation: tokensToCurrency(sale.baseAllocation),
            isApprox: false,
        };
    }
    // Calculate approximately
    var whitelistAlloc = sale.hasWhitelist && ((_b = (_a = sale.limits) === null || _a === void 0 ? void 0 : _a.max) === null || _b === void 0 ? void 0 : _b.gtn(0))
        ? currencyToTokens(sale.limits.max).muln(whitelistedN)
        : _launchpadConstants_1.ZERO_BN;
    var baseAllocation = sale.isTiered && sale.totalWeights
        ? sale.tokensForSale
            .sub(whitelistAlloc)
            .divn(sale.totalWeights)
            .muln(useLevelManager_1.MULTIPLIER_DECIMALS)
        : _launchpadConstants_1.ZERO_BN;
    return {
        baseTokensAllocation: baseAllocation,
        baseCurrencyAllocation: tokensToCurrency(baseAllocation),
        isApprox: true,
    };
}
exports.useSaleBaseAllocation = useSaleBaseAllocation;
